export default __webpack_public_path__ + "static/media/cardHouse.4304a7c1.svg";